export const config = {
  title: "Ettlinger Bike Repair | Mobile Bicycle Repair in Lakeville, MN",
  meta: {
    description:
      "Ettlinger Bike Repair offers professional mobile bicycle repair and maintenance services in Lakeville, MN. From tune-ups and flat fixes to drivetrain cleaning and wheel truing, we come to you for convenient, expert service.",
    keywords: [
      "Ettlinger Bike Repair",
      "mobile bike repair Lakeville",
      "bicycle tune-ups",
      "bike maintenance Minnesota",
      "flat tire repair",
      "wheel truing",
      "bike cleaning"
    ],
    author: "Ettlinger Bike Repair",
    canonicalUrl: "https://ettlingerbikerepair.com/",
  },
  sections: {
    header: {
      businessName: "Ettlinger Bike Repair",
    },
    sectionB: {
      heroTitle: "Convenient Mobile Bike Repair",
      heroSubtitle: "Expert Bicycle Service at Your Doorstep in Lakeville, MN",
      learnAboutText: "Schedule a Service",
      phoneNumber: "6123910027",
      phoneLabel: "(612) 391-0027",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/615281154/photo/mechanic-repairing-bicycle-rear-wheel.jpg?s=612x612&w=0&k=20&c=nBkGWTy2ERwp-8dATCiNSo_iAP1AVfpFScAwNr-wFoU=",
      cardData: [
        {
          title: "Bike Tune-Ups",
          description: "Full inspections, adjustments, and lubrication for optimal performance.",
        },
        {
          title: "Flat Tire Repair",
          description: "Quick fixes and tube replacements to get you rolling again.",
        },
        {
          title: "Wheel Truing",
          description: "Precision wheel alignment to ensure a smooth and safe ride.",
        },
      ],
      description:
        "Ettlinger Bike Repair specializes in mobile bicycle services, delivering expert care right to your home or workplace. From tune-ups and flat repairs to drivetrain cleaning and wheel adjustments, we keep your bike road-ready and safe.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Comprehensive bicycle repair and maintenance solutions brought directly to you.",
      cards: [
        {
          title: "Tune-Ups & Safety Checks",
          description: "Thorough inspections, brake and gear adjustments, and lubrication.",
          imageSrc: "https://media.istockphoto.com/id/614342476/photo/mechanic-repairing-bicycle-transmission.jpg?s=612x612&w=0&k=20&c=MtEx3qf-V9_MmPUhaZYqnBdD0Yqx48UHG7ajalWuQws=",
          imageAlt: "Bike Tune-Up",
        },
        {
          title: "Drivetrain Cleaning",
          description: "Deep cleaning of chains, cassettes, and derailleurs for smooth shifting.",
          imageSrc: "https://media.istockphoto.com/id/619375672/photo/fixing-the-bicycle-wheel.jpg?s=612x612&w=0&k=20&c=_V1nwhuKxnOFIS7yiIa30YqbE-dlWnV2fBszME0E5u4=",
          imageAlt: "Drivetrain Cleaning",
        },
        {
          title: "Wheel Truing & Adjustments",
          description: "Professional wheel alignment and spoke tension balancing.",
          imageSrc: "https://media.istockphoto.com/id/1140335388/photo/cute-caucasian-female-worker-holding-and-repairing-bicycle-wheel-while-standing-in-bicycle.jpg?s=612x612&w=0&k=20&c=kIqjm1gRDPQ_G2JiIZUdW14vCyWM769vIenC351xCWk=",
          imageAlt: "Wheel Truing",
        },
      ],
      otherServicesTitle: "Other Services",
      otherServicesList: [
        "Flat Tire Repair & Tube Replacement",
        "Brake & Gear Adjustments",
        "Bike Cleaning & Lubrication",
        "Mobile On-Site Service",
        "Convenient Scheduling",
      ],
    },
    sectionD: {
      aboutTitle: "About Ettlinger Bike Repair",
      aboutImage: {
        src: "https://media.istockphoto.com/id/843098734/photo/technicians-are-repairing-bicycles-at-shop-sells.jpg?s=612x612&w=0&k=20&c=XLKj_3FrFVZneXWxt2VGAnLYRrC7bL3ZUo80QvchWxw=",
        alt: "Ettlinger Bike Repair Service",
      },
      aboutText: [
        "Ettlinger Bike Repair is a Lakeville-based mobile bike repair service dedicated to making bicycle maintenance convenient and accessible.",
        "Whether you need a quick tune-up, drivetrain cleaning, or a flat tire fix, we come directly to you — ensuring your bike stays in top shape without disrupting your day.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Ettlinger Bike Repair Logo",
      businessName: "Ettlinger Bike Repair",
      contact: {
        phone: "6123910027",
        phoneLabel: "(612) 391-0027",
        email: "service.ettlingerbikerepair@gmail.com",
        website: "https://ettlingerbikerepair.com/",
        address: "Lakeville, MN",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedIn: null,
        youtube: null,
        tiktok: null,
      },
    },
    sectionF: {
      address: "Lakeville, MN",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2922.5565!2d-93.242!3d44.649!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87f63f3e0c12345%3A0xabcdef123456789!2sLakeville%2C%20MN!5e0!3m2!1sen!2sus!4v1714567890123!5m2!1sen!2sus",
    },
  },
};

export default config;
